import React, { useState, useEffect } from "react";
import { Avatar, Box, Button, Divider, IconButton } from "@mui/material";
import apiConnect from "../api/apiConnect";
import IconNull from "../componentsStyled/icon/iconNull";
import LoadingBox from "./LoadingBox";
import { isMobile } from "react-device-detect";

interface Pedido {
  id: string;
  status: string;
  date: string;
  total: string;
  partial_total: string;
  discount: string;
  shipment_value: string;
  shipment_date: string;
  packaging_value: string;
  point_sale: string;
  payment_method: string;
  delivery_date: string;
  fullname: string;
  cellphone: string;
  phone: string;
  email: string;
  zip_code: string;
  state: string;
  city: string;
  neighborhood: string;
  address: string;
  number: string;
  complement: string;
  allowed_clique_retire: boolean;
  Products: Array<{
    product_sold_id: string;
    product_id: string;
    name: string;
    allowed: boolean;
    is_personalized: boolean;
    additional_information: string;
    variant_type: string;
    variant_value: string;
    variant_id: string;
    quantity: string;
    price: string;
    original_price: string;
    cost_price: string;
    img: string;
    url: string;
  }>;
}

const ListaProdutosDetails: React.FC<any> = ({ selectedId }) => {
  const [pedido, setPedido] = useState<Pedido | null>(null);
  const [loading, setloading] = useState<boolean>(true);

  const handleGetDeatil = async () => {
    setloading(true);
    let auth = localStorage.getItem("auth");
    const authObj = JSON.parse(auth);

    apiConnect.apiAPP
      .get(`order/get/${selectedId}`, {
        headers: {
          Authorization: "Basic " + authObj.basicAuth,
        },
      })
      .then((resp) => {
        setPedido(resp.data);
        setloading(false);
      })
      .catch((err) => {
        setloading(false);
        console.log("Error get pedido details:", err);
      });
  };

  const formatDate = (dateTimeString: string) => {
    const options: Intl.DateTimeFormatOptions = { day: "numeric", month: "numeric", year: "numeric" };
    return new Date(dateTimeString).toLocaleDateString("pt-BR", options);
  };

  useEffect(() => {
    if (selectedId === "#") {
      return;
    }
    handleGetDeatil();
  }, [selectedId]);
  return (
    <Box>
      {loading ? (
        <Box marginY={10}>
          <LoadingBox loadType="static" />
        </Box>
      ) : pedido !== null ? (
        <Box pb={5}>
          <p style={{ fontSize: isMobile ? 18 : 25, fontWeight: isMobile ? 500 : 700, fontFamily: "Helvetica Neue" }}>Pedido #{pedido?.id}</p>
          {/* pedido data/pagamento */}
          <Box display={"flex"} mt={4} width={{ xs: "100%", md: "60%" }} justifyContent={"space-between"}>
            <Box>
              <label style={{ color: "#A2A2A2", fontFamily: "Helvetica Neue", fontWeight: 300 }}>Data do Pedido</label>
              <p>{formatDate(pedido?.date)}</p>
            </Box>
            <Box>
              <label style={{ color: "#A2A2A2" }}>Método de Pagamento</label>
              <p style={{ color: "#000" }}>{pedido.payment_method}</p>
            </Box>
          </Box>
          {/* pedido data/pagamento */}

          <Box display={"flex"} flexDirection={{ xs: "column", md: "row" }} gap={{ xs: 1, md: 5 }}>
            {/* Lista pedidos */}
            <Box width={{ xs: "100%", md: "50%" }} mt={5}>
              <p style={{ color: "#A2A2A2" }}>Lista de Produtos</p>
              <Box overflow={{ xs: "initial", md: "auto" }} height={{ xs: "100%", md: 250 }} display={"flex"} flexDirection={"column"} mt={2} gap={2}>
                {pedido.Products.length > 0 ? (
                  pedido.Products.map((produto, i) => {
                    return (
                      <Box key={i} display={"flex"} p={2} borderBottom={"2px solid #f1f1f1"}>
                        <Avatar variant="rounded" src={produto.img} style={{ width: 110, height: 110 }} />
                        <Box ml={1}>
                          <p
                            style={{
                              fontFamily: "Gotham",
                              fontSize: 21,
                              // letterSpacing: 1,
                              fontWeight: 400,
                              textOverflow: "ellipsis",
                              lineClamp: 1,
                              overflow: "hidden",
                              display: "-webkit-box",
                              WebkitLineClamp: 1,
                              WebkitBoxOrient: "vertical",
                            }}>
                            {produto.name}
                          </p>
                          <p
                            style={{
                              fontFamily: "Gotham",
                              fontWeight: 300,
                              letterSpacing: 1,
                            }}>
                            {produto.variant_type}: {produto.variant_value}
                          </p>
                          <p
                            style={{
                              fontFamily: "Gotham",
                              fontWeight: 300,
                              letterSpacing: 1,
                            }}>
                            Quantidade: {produto.quantity}
                          </p>
                          <p
                            style={{
                              fontFamily: "Gotham",
                              fontWeight: 500,
                              letterSpacing: 2,
                            }}>
                            {new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(Number(produto.price))}
                          </p>
                        </Box>
                      </Box>
                    );
                  })
                ) : (
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <IconNull width={50}></IconNull>
                    <p style={{ color: "#777" }}>Não há produtos a serem listado</p>
                  </div>
                )}
              </Box>
            </Box>
            {/* Lista pedidos */}

            {/* Resumo pedido */}
            <Box width={{ xs: "100%", md: "30%" }} mt={5} display={"flex"} flexDirection={"column"} gap={2}>
              <p style={{ color: "#A2A2A2" }}>Resumo do Pedido</p>
              <Box display={"flex"} flexDirection={"column"} gap={3}>
                <Box display={"flex"} alignItems={"center"} justifyContent={"space-between"}>
                  <p>Produtos</p>
                  <p>{new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(Number(pedido.partial_total))}</p>
                </Box>
                <Box display={"flex"} alignItems={"center"} justifyContent={"space-between"}>
                  <p>Descontos</p>
                  <p>{new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(Number(pedido.discount ?? 0))}</p>
                </Box>
                <Box display={"flex"} alignItems={"center"} justifyContent={"space-between"}>
                  <p>Frete</p>
                  <p>{new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(Number(pedido.shipment_value ?? 0))}</p>
                </Box>
                {pedido?.packaging_value?.length > 1 ? (
                  <Box display={"flex"} alignItems={"center"} justifyContent={"space-between"}>
                    <p>Embalagens</p>
                    <p>{new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(Number(pedido.packaging_value))}</p>
                  </Box>
                ) : null}
                <Divider />
                <Box display={"flex"} alignItems={"center"} justifyContent={"space-between"}>
                  <p>Total</p>
                  <p>{new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(Number(pedido.total))}</p>
                </Box>
              </Box>
            </Box>
            {/* Resumo pedido */}
          </Box>
        </Box>
      ) : (
        <Box display={"flex"} flexDirection={"column"} alignItems={"center"} justifyContent={"center"} height={300}>
          <IconNull width={50}></IconNull>
          <p style={{ color: "#777" }}>Nenhum pedido encontrado</p>
        </Box>
      )}
    </Box>
  );
};

export default ListaProdutosDetails;
